import React, { createContext, ReactElement } from 'react'

import { PropertyAPIResponse as PropertyType } from 'src/types/property'

const PropertyContext = createContext<PropertyType | null>(null)

const PropertyProvider = ({ children, value }: { children: ReactElement; value: PropertyType }) => {
  return <PropertyContext.Provider value={value}>{children}</PropertyContext.Provider>
}

export { PropertyContext, PropertyProvider }
